import { Vault } from "../../libs/storage.js";

export { Experiment, ExperimentValues };

const StorageName = "e_values";
const DefaultExperimentValue = null;
const ParamNameExperimentG1 = "experiment_g1";
const ParamNameExperimentG2 = "experiment_g2";
const ParamNameExperimentG3 = "experiment_g3";
const ParamNameExperimentG4 = "experiment_g4";

interface ExperimentValues {
  [ParamNameExperimentG1]: string | null;
  [ParamNameExperimentG2]: string | null;
  [ParamNameExperimentG3]: string | null;
  [ParamNameExperimentG4]: string | null;
}

// Implemented following the same logic as Tracking.js
class Experiment {
  private _currentExperiment: ExperimentValues = {
    [ParamNameExperimentG1]: "",
    [ParamNameExperimentG2]: "",
    [ParamNameExperimentG3]: "",
    [ParamNameExperimentG4]: "",
  };

  constructor() {
    if (!this._searchUrlParamsInUrl()) {
      const experimentFromStorage = Vault.get(StorageName);
      this._currentExperiment = experimentFromStorage;

      if (experimentFromStorage === false) {
        this._currentExperiment = {
          [ParamNameExperimentG1]: DefaultExperimentValue,
          [ParamNameExperimentG2]: DefaultExperimentValue,
          [ParamNameExperimentG3]: DefaultExperimentValue,
          [ParamNameExperimentG4]: DefaultExperimentValue,
        };
      }
    }

    this._save();
    this._resetUrl();
  }

  getAdditionalDataToMessage(): ExperimentValues {
    const { experiment_g1, experiment_g2, experiment_g3, experiment_g4 } =
      Vault.get(StorageName);

    return {
      [ParamNameExperimentG1]: experiment_g1 || "",
      [ParamNameExperimentG2]: experiment_g2 || "",
      [ParamNameExperimentG3]: experiment_g3 || "",
      [ParamNameExperimentG4]: experiment_g4 || "",
    };
  }

  private _getUrlParameterObject(lowercase = true): URLSearchParams {
    const queryString = lowercase
      ? window.location.search.toLowerCase()
      : window.location.search;

    return new URLSearchParams(queryString);
  }

  private _searchUrlParamsInUrl(): boolean {
    let response = false;

    const getParameters = this._getUrlParameterObject();
    const experimentUrl: ExperimentValues = {
      [ParamNameExperimentG1]: getParameters.get(ParamNameExperimentG1),
      [ParamNameExperimentG2]: getParameters.get(ParamNameExperimentG2),
      [ParamNameExperimentG3]: getParameters.get(ParamNameExperimentG3),
      [ParamNameExperimentG4]: getParameters.get(ParamNameExperimentG4),
    };

    if (this._useExperimentUrlValues(experimentUrl)) {
      for (const property in experimentUrl) {
        if (experimentUrl[property] === null) {
          experimentUrl[property] = "";
        }
      }

      this._currentExperiment = experimentUrl;

      response = true;
    }

    return response;
  }

  private _useExperimentUrlValues(
    experimentUrlValues: ExperimentValues,
  ): boolean {
    let response = false;

    if (
      this._isValidValue(experimentUrlValues[ParamNameExperimentG1]) ||
      this._isValidValue(experimentUrlValues[ParamNameExperimentG2]) ||
      this._isValidValue(experimentUrlValues[ParamNameExperimentG3]) ||
      this._isValidValue(experimentUrlValues[ParamNameExperimentG4])
    ) {
      response = true;
    }

    return response;
  }

  private _isValidValue(value: unknown): boolean {
    let response = false;

    if (value !== false && value !== null && value !== undefined) {
      response = true;
    }

    return response;
  }

  private _save(): void {
    Vault.set(StorageName, this._currentExperiment, { expires: "1d" });
  }

  private _resetUrl(): void {
    const urlSearchStringObject = this._getUrlParameterObject(false);
    const experimentParametersNameToBeRemoved = Object.getOwnPropertyNames(
      this._currentExperiment,
    );

    for (const experiment of experimentParametersNameToBeRemoved) {
      urlSearchStringObject.delete(experiment);
    }

    const path = location.pathname,
      searchSeparator = urlSearchStringObject.toString() !== "" ? "?" : "";

    const newUrl =
      path + searchSeparator + urlSearchStringObject.toString() + location.hash;
    window.history.replaceState({}, "", newUrl);
  }
}
